/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
} from 'antd';
import { CheckCircleOutlined, RedoOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import ModalConfirmation from 'components/ModalConfirmation';
import { getEstadosGlobales } from 'api/catalogos/index';
import {
  getMotivosDeLiquidaciones,
  getMotivoDeLiquidacion,
  postMotivoDeLiquidacion,
  deleteMotivoDeLiquidacion,
  patchMotivoDeLiquidacion,
} from 'api/catalogos/motivosDeLiquidaciones';
import { checkToken } from 'api/utils';
import {
  SLUG_PATTERN,
} from 'utils/patterns';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_INACTIVO,
  ESTATUS_RECHAZADO,
} from 'utils/constants';

export const motivosDeLiquidacionesPermission = {
  permissionModel: 'motivodeliquidacion',
  catalogsModels: [],
  tabsModels: [],
};

const MotivosDeLiquidaciones = ({ permission }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState();
  const [open, setVisible] = useState();
  const [visibleAlert, setVisibleAlert] = useState();
  const [estados, setEstados] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [form] = Form.useForm();
  const [formDatos] = Form.useForm();
  const [disableAuth, setDisableAuth] = useState(false);
  const [disableReactivar, setDisableReactivar] = useState(true);
  const [visibleReactivarConfirmation, setVisibleReactivarConfirmation] = useState(false);

  const formInstances = [
    form,
    formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getMotivosDeLiquidaciones();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getMotivosDeLiquidaciones(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setDisableReactivar(true);
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    formDatos.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _motivoDeMovimientoDeEmpleado = await getMotivoDeLiquidacion(match.id);
    if (_motivoDeMovimientoDeEmpleado?.estados_globales === ESTATUS_ACTIVO
      || _motivoDeMovimientoDeEmpleado?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
      || estado?.id === ESTATUS_ACTIVO));
    }
    if (_motivoDeMovimientoDeEmpleado?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_motivoDeMovimientoDeEmpleado?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    setTimeout(() => {
      if (_motivoDeMovimientoDeEmpleado) {
        form.resetFields();
        formDatos.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_motivoDeMovimientoDeEmpleado));
          formDatos.setFieldsValue(formatReceived(_motivoDeMovimientoDeEmpleado));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        ...formDatos.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      const saved = await (key
        ? patchMotivoDeLiquidacion(key, values)
        : postMotivoDeLiquidacion(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteMotivoDeLiquidacion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    const isAutorizado = record?.estados_globales === ESTATUS_AUTORIZADO;
    const isInactivo = record?.estados_globales === ESTATUS_INACTIVO;
    const isActivo = record?.estados_globales === ESTATUS_ACTIVO;
    const isCancelado = record?.estados_globales === ESTATUS_CANCELADO;
    const isRechazado = record?.estados_globales === ESTATUS_RECHAZADO;
    setDisableAuth(isAutorizado || isInactivo || isCancelado || isRechazado);
    setDisableReactivar(isActivo);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchMotivoDeLiquidacion(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  const handleOnFinishReactivarConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede Reactivar un Motivo de Liquidación Activo');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_ACTIVO,
      };
      const res = await patchMotivoDeLiquidacion(key, vals);
      if (res) {
        await fetchData();
        onSuccess(res);
        setVisibleReactivarConfirmation(false);
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 100,
    },
    {
      titleText: 'Concepto',
      dataIndex: 'motivo',
      key: 'motivo',
      width: 250,
    },
    {
      titleText: 'Fundamento',
      dataIndex: 'fundamento',
      key: 'fundamento',
      width: 250,
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'especificacion',
      key: 'especificacion',
      width: 250,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 100,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          disableDelete={
            [ESTATUS_AUTORIZADO, ESTATUS_CANCELADO, ESTATUS_RECHAZADO].includes(
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales,
            )
          }
          customActions={[
            {
              onClick: () => setConfirmationVisible(true),
              permission: { model: 'motivodeliquidacion', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length || disableAuth,
            },
            {
              onClick: () => setVisibleReactivarConfirmation(true),
              permission: { model: 'motivodeliquidacion', action: 'reactivar' },
              text: 'Reactivar',
              icon: <RedoOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length || disableReactivar,
            },
          ]}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          footer={null}
          width="45%"
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Motivo de Liquidación`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!selectedRowKeys?.length || !disableAuth}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="clave"
                rules={rules.clave}
                label="Clave"
                hasFeedback
              >
                <Input
                  allowClear
                  disabled={estatusAutorizado || estatusInactivo}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="motivo"
                label="Concepto"
                rules={rules.required}
                hasFeedback
              >
                <Input
                  disabled={estatusAutorizado || estatusInactivo}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="fundamento"
                label="Fundamento"
                hasFeedback
              >
                <Input
                  disabled={estatusAutorizado || estatusInactivo}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="especificacion"
                label="Observaciones"
                hasFeedback
              >
                <Input.TextArea
                  autoSize={{ minRows: 4, maxRows: 4 }}
                  disabled={estatusAutorizado || estatusInactivo}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                rules={rules.estatus}
                hasFeedback
                initialValue={1}
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estadosFiltered}
                  disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                  onChange={(val) => {
                    if (val === ESTATUS_INACTIVO) {
                      setConfirmationVisibleEstatus(true);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Motivo de Liquidación ${form.getFieldValue('motivo')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Motivo de Liquidación ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          ConfirmInactive
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          contentTitle={`Inactivar el Motivo de Liquidación ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishReactivarConfirmation}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => {
            setVisibleReactivarConfirmation(false);
            onCancel();
          }}
          open={visibleReactivarConfirmation}
          contentTitle={`Reactivar el Motivo de Liquidación ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default MotivosDeLiquidaciones;
